import { createContext, useContext, useEffect, useMemo, useState } from 'react'

const messages = {
  pt: {
    brand: 'Domusfamilyhub',
    header: { subtitle: 'Gestão Familiar Inteligente' },
    welcome: {
      title: 'Bem-vindos ao Domusfamilyhub',
      message: 'Este é um espaço seguro de introspecção familiar. Aqui vocês podem organizar tarefas, finanças, saúde e memórias com privacidade e respeito.' ,
      dismiss: 'Começar'
    },
    nav: {
      dashboard: 'Dashboard',
      finance: 'Finanças',
      tasks: 'Tarefas',
      calendar: 'Calendário',
      health: 'Saúde',
      shopping: 'Compras',
      familyBoard: 'Mural da Família',
      itemsControl: 'Controle de Itens',
      locator: 'Localizador',
      videoRoom: 'Sala de Vídeo',
      settings: 'Configurações'
    },
    login: {
      welcomeBack: 'Bem-vindo de volta',
      email: 'E-mail',
      password: 'Senha',
      enter: 'Entrar',
      enterWithGoogle: 'Entrar com Google',
      enterWithGoogleDemo: 'Entrar com Google (Demo)',
      backHome: 'Voltar para a Home',
      placeholderEmail: 'voce@exemplo.com',
      placeholderPassword: 'Sua senha'
    }
  },
  en: {
    brand: 'Domusfamilyhub',
    header: { subtitle: 'Smart Family Management' },
    welcome: {
      title: 'Welcome to Domusfamilyhub',
      message: 'This is a safe space for family introspection. Organize tasks, finances, health and memories with privacy and respect.',
      dismiss: 'Get started'
    },
    nav: {
      dashboard: 'Dashboard',
      finance: 'Finance',
      tasks: 'Tasks',
      calendar: 'Calendar',
      health: 'Health',
      shopping: 'Shopping',
      familyBoard: 'Family Board',
      itemsControl: 'Items Control',
      locator: 'Locator',
      videoRoom: 'Video Room',
      settings: 'Settings'
    },
    login: {
      welcomeBack: 'Welcome back',
      email: 'Email',
      password: 'Password',
      enter: 'Sign in',
      enterWithGoogle: 'Sign in with Google',
      enterWithGoogleDemo: 'Sign in with Google (Demo)',
      backHome: 'Back to Home',
      placeholderEmail: 'you@example.com',
      placeholderPassword: 'Your password'
    }
  },
  es: {
    brand: 'Domusfamilyhub',
    header: { subtitle: 'Gestión Familiar Inteligente' },
    welcome: {
      title: 'Bienvenidos a Domusfamilyhub',
      message: 'Este es un espacio seguro de introspección familiar. Organicen tareas, finanzas, salud y recuerdos con privacidad y respeto.',
      dismiss: 'Comenzar'
    },
    nav: {
      dashboard: 'Panel',
      finance: 'Finanzas',
      tasks: 'Tareas',
      calendar: 'Calendario',
      health: 'Salud',
      shopping: 'Compras',
      familyBoard: 'Muro Familiar',
      itemsControl: 'Control de Ítems',
      locator: 'Localizador',
      videoRoom: 'Sala de Video',
      settings: 'Configuración'
    },
    login: {
      welcomeBack: 'Bienvenido de nuevo',
      email: 'Correo',
      password: 'Contraseña',
      enter: 'Ingresar',
      enterWithGoogle: 'Ingresar con Google',
      enterWithGoogleDemo: 'Ingresar con Google (Demo)',
      backHome: 'Volver al Inicio',
      placeholderEmail: 'tu@ejemplo.com',
      placeholderPassword: 'Tu contraseña'
    }
  }
}

const I18nContext = createContext({})

export { I18nContext }

export const I18nProvider = ({ children }) => {
  const [lang, setLang] = useState(localStorage.getItem('lang') || 'pt')

  useEffect(() => {
    localStorage.setItem('lang', lang)
    document.documentElement.lang = lang
  }, [lang])

  const t = useMemo(() => {
    const bundle = messages[lang] || messages.pt
    const getter = (path) => path.split('.').reduce((acc, key) => acc?.[key], bundle) || path
    return getter
  }, [lang])

  const value = { lang, setLang, t, messages }
  return (
    <I18nContext.Provider value={value}>
      {children}
    </I18nContext.Provider>
  )
}

export default I18nContext
